import {Sheet, SheetContent, SheetTrigger} from '@/components/ui/Sheet';
import {Avatar, AvatarFallback, AvatarImage} from '@/components/ui/Avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu';
import {handleSignOut} from '@/util/aws/cognito-actions';
import {useNavigate} from 'react-router';
import {toast} from 'sonner';

export default function AvatarCollapsibleMenu() {
  const navigate = useNavigate();

  async function onSubmit() {
    const {error} = await handleSignOut();

    if (error) {
      toast.error('Error', {
        description: error.message,
      });
      return;
    }

    navigate('/sign-in');
    toast.warning('Signed out.');
  }

  return (
    <div>
      <Sheet>
        <DropdownMenu>
          <DropdownMenuTrigger>
            <Avatar>
              <AvatarImage src="https://github.com/shadcn.png" />
              <AvatarFallback>CN</AvatarFallback>
            </Avatar>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuLabel>My Account</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={onSubmit}
              className="hover:bg-destructive text-destructive focus:bg-destructive focus:text-white"
            >
              <button>
                <div>Sign Out</div>
              </button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <SheetContent className="overflow-auto">le</SheetContent>
      </Sheet>
    </div>
  );
}
